import React, { CSSProperties, FunctionComponent, InputHTMLAttributes, useEffect, useState } from 'react';
import { HTMLInputElement } from 'window-or-global';
import Icon, { IconName } from '../../icons/icon/icon-component';
import styles from './fixed-part-text-component.module.scss';

type FixedPartTextProps = {
  fixedPart: string;
  /**
   * 3d | account | add | add-cart | attributes | back | basket | bin |
   * done | chev-down | chev-left | chev-right | chev-up | close | compare |
   * cookie | cookie-blocked | cookie-whole | envelope | filter | grid |
   * info | insert | list | man | menu | more-hor | more-vert | pdf |
   * phone | search | settings | sort | sort-down | table |
   * visibility | visibility-off| website
   **/
  icon?: IconName;
  iconWidth?: number;
  iconHeight?: number;
  /**in rem */
  errorMessageSpacing?: number;
  errorMessage?: string;
  isValid?: boolean;
  textBackground?: 'white' | 'grey';
  validationCallback?: (value: string) => boolean;
} & InputHTMLAttributes<HTMLInputElement>;

/**
 * Fixed-part text component
 *
 * https://www.figma.com/file/DRx0SLXRzam3REAcT3QH16/Responsive-Checkout-MVP?node-id=3899%3A704628
 */
export const FixedPartText: FunctionComponent<FixedPartTextProps> = ({
  errorMessageSpacing = 1.6,
  textBackground = 'grey',
  fixedPart,
  icon,
  iconWidth,
  iconHeight,
  className,
  errorMessage,
  isValid,
  disabled,
  validationCallback,
  ...inputAttributes
}) => {
  const [isValidState, setIsValidState] = useState(isValid ?? true);

  // update state if isValid changes
  useEffect(() => {
    setIsValidState(isValid ?? true);
  }, [isValid]);

  return (
    <div className={`${styles['fixed-part-text-component']} ${disabled ? styles.disabled : ''} ${className ? className : ''} `}>
      <div
        className={`${styles['input-container']}  ${!isValidState ? styles.error : ''} ${
          textBackground ? styles[textBackground] : styles.grey
        }`}
        style={
          {
            '--icon-width': `${iconWidth ?? 24}px`,
          } as React.CSSProperties
        }
      >
        <span className={styles['fixed-part']}>{fixedPart}</span>
        <input onBlur={onFocusLost} type='text' className={styles.text} disabled={disabled} {...inputAttributes} />
        {icon ? (
          <Icon
            name={icon}
            className={styles.icon}
            style={{ '--icon-height': `${(iconHeight ?? 24) / 2}px` } as React.CSSProperties}
            width={iconWidth}
            height={iconHeight}
          />
        ) : null}
      </div>
      {errorMessage && !isValidState && (
        <p style={{ '--message-spacing': `${errorMessageSpacing}rem` } as CSSProperties} className={styles['error-text']}>
          {errorMessage}
        </p>
      )}
    </div>
  );

  function onFocusLost(e: React.FocusEvent<HTMLInputElement>) {
    if (validationCallback) {
      setIsValidState(validationCallback(e.currentTarget.value));
    }
  }
};

export default FixedPartText;
